import {
  Button,
  colours,
  DataDisplayWithAdornment,
  Icon,
  Popover,
  type DataDisplayProps,
} from "@validereinc/common-components";
import classNames from "classnames/bind";
import React, { type PropsWithChildren } from "react";
import styles from "./DataSetSubmissionRowTableErrorDataDisplay.module.css";

const cx = classNames.bind(styles);

export const DataSetSubmissionRowTableErrorDataDisplay = ({
  intent = "error",
  children,
  errorType,
  errorMessage,
  errorSuggestions,
  ...restProps
}: PropsWithChildren<
  {
    intent?: "error" | "warning";
    errorType: string;
    errorMessage?: string;
    errorSuggestions?: string | string[];
  } & Omit<DataDisplayProps, "value">
>) => {
  return (
    <DataDisplayWithAdornment
      {...restProps}
      showAdornment
      adornmentSlot={() => (
        <Popover
          contentClassName={cx("popover")}
          contentRender={() => (
            <div className={cx("popover-container")}>
              <div className={cx("summary")}>
                <div className={cx("icon-container")}>
                  <Icon
                    variant={intent === "error" ? "warning-octagon" : "warning"}
                    colour={
                      intent === "error"
                        ? colours.colours.status.error
                        : colours.colours.status.warning
                    }
                  />
                </div>
                <p className={cx("title")}>{errorType}</p>
              </div>
              <div className={cx("details")}>
                {errorSuggestions?.length ? (
                  <ol className={cx("details-list")}>
                    <li>
                      <p className={cx("label")}>Details</p>
                      <p className={cx("value")}>{errorMessage}</p>
                    </li>
                    <li>
                      <p className={cx("label")}>Supported Value(s)</p>
                      <div className={cx("value")}>
                        {Array.isArray(errorSuggestions) ? (
                          <ol className={cx("suggestions-list")}>
                            {errorSuggestions?.map((sg) => (
                              <li key={sg}>{sg ?? "none"}</li>
                            ))}
                          </ol>
                        ) : (
                          errorSuggestions
                        )}
                      </div>
                    </li>
                  </ol>
                ) : (
                  errorMessage
                )}
              </div>
            </div>
          )}
        >
          <Button
            variant="ghost"
            icon={intent === "error" ? "warning-octagon" : "warning"}
            iconProps={{
              colour:
                intent === "error"
                  ? colours.colours.status.error
                  : colours.colours.status.warning,
            }}
          />
        </Popover>
      )}
    >
      {children ?? "-"}
    </DataDisplayWithAdornment>
  );
};
